export enum StoreId {
  HOME = 'home',
  INICIADORA_PIX_INTELIGENTE = 'iniciadora-pix-inteligente',
  TOKEN = 'token',
  RECEPTORA_SIMPLES = 'receptora-simples',
  PORTABILIDADE_CREDITO = 'portabilidade-credito',
}
